import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
var _templateObject, _templateObject2;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
import { BlueElement, nothing, register as blueRegister } from '@onviobr/element';
import { getHigherZIndex } from '@onviobr/ui-elements';
import { EventType } from '..';
import { firstFocusableKeyHandler, lastFocusableKeyHandler } from '../accessibility-utility';
import { defaultOptions } from '../dms-viewer-interface';
import { buttonStyles, checkboxStyles } from './common-styles.css';
import { styles } from './print-modal.css';
var PrintModal = /*#__PURE__*/function (_BlueElement) {
  function PrintModal() {
    var _this;
    _classCallCheck(this, PrintModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, PrintModal, [].concat(args));
    _this.strings = defaultOptions.strings;
    _this.annotationsAllowed = false;
    _this.shouldFocus = true;
    _this.focusCloseBtn = false;
    return _this;
  }
  _inherits(PrintModal, _BlueElement);
  return _createClass(PrintModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      return this.html(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t\t<bm-modal modalTitle=", " modalSize=\"medium\" .backdropClose=", " @closeKeyDown=", " style=\"z-index:", ";\"\n\t\t\t.focusModal=", " .focusCloseBtn=", " @close=", ">\n\t\t\t\t", "\n\t\t\t\t<div class=\"watermark-link\">\n\t\t\t\t\t<a @click=", " tabindex=\"0\" href=\"#\">", "</a>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"footer\" tabindex=\"-1\">\n\t\t\t\t\t<button id=\"print-btn\" class=\"btn btn-primary btn-lg\" @click=", "\n\t\t\t\t\t@keydown=", "\n\t\t\t\t\t@keyup=", ">", "</button>\n\t\t\t\t</div>\n\t\t\t</bm-modal>\n\t\t"])), this.strings.printOptions, false, function () {
        return firstFocusableKeyHandler(_this2.renderRoot, '#print-btn');
      }, getHigherZIndex() + 1, this.shouldFocus, this.focusCloseBtn, this.closeHandler, this.annotationsAllowed ? this.html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t<div class=\"checkbox-container\">\n\t\t\t\t\t\t\t\t\t<label class=\"checkbox-label\">\n\t\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" checked id=\"include-annotations\">\n\t\t\t\t\t\t\t\t\t\t<span class=\"check-box\"><span class=\"check-mark\"></span></span>\n\t\t\t\t\t\t\t\t\t\t", "\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"checkbox-container\">\n\t\t\t\t\t\t\t\t\t<label class=\"checkbox-label\">\n\t\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" id=\"include-comments\">\n\t\t\t\t\t\t\t\t\t\t<span class=\"check-box\"><span class=\"check-mark\"></span></span>\n\t\t\t\t\t\t\t\t\t\t", "\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t"])), this.strings.includeAnnotations, this.strings.includeComments) : nothing, this.openWatermarkModalHandler, this.strings.addWatermark, this.printHandler, function (e) {
        return lastFocusableKeyHandler(e, function () {
          _this2.focusCloseBtn = true;
        });
      }, function (e) {
        return lastFocusableKeyHandler(e, function () {
          _this2.focusCloseBtn = false;
        });
      }, this.strings.printButton);
    }
  }, {
    key: "createRenderRoot",
    value: function createRenderRoot() {
      var modalContainer = document.createElement('div');
      modalContainer.style.setProperty('z-index', "".concat(getHigherZIndex() + 1));
      document.body.appendChild(modalContainer);
      return modalContainer.attachShadow({
        mode: 'open'
      });
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      _superPropGet(PrintModal, "disconnectedCallback", this, 3)([]);
      var renderRoot = this.renderRoot;
      renderRoot.host.parentElement.removeChild(renderRoot.host);
    }
  }, {
    key: "printHandler",
    value: function printHandler() {
      var _this$renderRoot$quer, _this$renderRoot$quer2;
      var includeAnnotations = !!((_this$renderRoot$quer = this.renderRoot.querySelector('#include-annotations')) !== null && _this$renderRoot$quer !== void 0 && _this$renderRoot$quer.checked);
      var includeComments = !!((_this$renderRoot$quer2 = this.renderRoot.querySelector('#include-comments')) !== null && _this$renderRoot$quer2 !== void 0 && _this$renderRoot$quer2.checked);
      this.dispatchEvent(new CustomEvent(EventType.Print, {
        detail: {
          includeAnnotations: includeAnnotations,
          includeComments: includeComments
        }
      }));
    }
  }, {
    key: "closeHandler",
    value: function closeHandler() {
      this.dispatchEvent(new CustomEvent(EventType.PrintModalClosed));
    }
  }, {
    key: "openWatermarkModalHandler",
    value: function openWatermarkModalHandler(e) {
      e.preventDefault();
      this.dispatchEvent(new CustomEvent(EventType.WatermarkModalOpened));
    }
  }], [{
    key: "is",
    get: function get() {
      return 'print-modal';
    }
  }, {
    key: "styles",
    get: function get() {
      return [styles, buttonStyles, checkboxStyles];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        strings: {
          type: Object
        },
        annotationsAllowed: {
          type: Boolean
        },
        shouldFocus: {
          type: Boolean
        },
        focusCloseBtn: {
          type: Boolean,
          attribute: false
        }
      };
    }
  }]);
}(BlueElement);
export { PrintModal as default };
export var registerPrintModal = function registerPrintModal() {
  return blueRegister(PrintModal);
};
